import React from "react";
import { Select } from "antd";

const { Option } = Select;

export default function PlazosCompra({ producto, setPlazoSeleccionado }) {
  const { precio_plazos } = producto;

  const obtenerPlazo = (_, data) => {
    console.log(_,data);
    if(!data.value){
        setPlazoSeleccionado();
        return
    }
    setPlazoSeleccionado(data.plazo);
  };

  return (
    <div style={{ marginTop: 8 }}>
      <div>Elige el plazo a pagar</div>
      <div style={{ width: "100%" }}>
        <Select style={{ width: "100%" }} defaultValue="" onChange={obtenerPlazo}>
          <Option value="">Selecciona uno</Option>
          {precio_plazos.map((res, index) => {
            return (
              <Option key={index} plazo={res} value={res.plazo}>
                {`$${res.precio} a ${res.plazo} ${
                  res.plazo === '30' ? "dias" : "meses"
                }`}
              </Option>
            );
          })}
        </Select>
      </div>
    </div>
  );
}
